export default "__VITE_ASSET__D8b7acuN__"